import { render, staticRenderFns } from "./BasePaginationTrigger.vue?vue&type=template&id=603a97a4&scoped=true&"
import script from "./BasePaginationTrigger.vue?vue&type=script&lang=js&"
export * from "./BasePaginationTrigger.vue?vue&type=script&lang=js&"
import style0 from "./BasePaginationTrigger.vue?vue&type=style&index=0&id=603a97a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a97a4",
  null
  
)

export default component.exports